export default "__VITE_ASSET__DqfTKQ27__"